import { Card } from "@/components/ui/card";
import { Link } from "react-router-dom";

interface GibRatingProps {
  rating?: number;
}

const GibRating = ({ rating = 9.2 }: GibRatingProps) => {
  return (
    <Card className="p-6">
      <div className="flex flex-col items-center">
        <h3 className="font-serif text-xl font-semibold text-black mb-2">GibRating™</h3>
        <span className="text-4xl font-bold mb-2">{rating}</span>
        <Link 
          to="/know-your-gib"
          className="text-sm text-blue-600 hover:text-blue-800"
        >
          Know Your Gib →
        </Link>
      </div>
    </Card>
  );
};

export default GibRating;